import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, signInWithPopup, getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import React from 'react';

// Firebase web config is public client configuration (it ships in the bundle
// by design; access control lives in Firebase security rules). Bake in the
// project defaults so builds never silently produce a broken bundle, and let
// env vars override for pointing at a different Firebase project.
const defaultFirebaseConfig = {
    apiKey: "AIzaSyA9j1ofXpRQcaLLqAQo0dxlBjQHaAbRAmU",
    authDomain: "mcapn-2ebe5.firebaseapp.com",
    projectId: "mcapn-2ebe5",
    storageBucket: "mcapn-2ebe5.appspot.com",
    messagingSenderId: "837395620806",
    appId: "1:837395620806:web:9b66921022c11283ae48c7",
    measurementId: "G-CZ92MZHCWL",
};

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || defaultFirebaseConfig.apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || defaultFirebaseConfig.authDomain,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || defaultFirebaseConfig.projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || defaultFirebaseConfig.storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || defaultFirebaseConfig.messagingSenderId,
    appId: process.env.REACT_APP_FIREBASE_APP_ID || defaultFirebaseConfig.appId,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || defaultFirebaseConfig.measurementId,
};

// Initialize app and create a single auth instance at module level.
// Reusing this singleton avoids the Firebase v11 "Pending promise was never set"
// assertion that occurs when getAuth() is called in different execution contexts.
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Keep the session across page reloads and browser restarts. Local persistence
// is the default, but setting it explicitly guards against environment quirks.
setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error('Failed to set auth persistence:', error);
});

function SubscribeUserAuthEvent(setUser) {
  React.useEffect(() => {
    // onIdTokenChanged fires on sign-in/sign-out AND on hourly token refresh,
    // so the app always holds a user with a fresh token instead of treating a
    // refresh as a logout.
    const unsubscribe = auth.onIdTokenChanged((user) => {
        if (user) {
            setUser(user);
        } else {
            setUser(null);
        }
    });
      return () => unsubscribe();
    }, [setUser]);
}

async function loginWithGoogle() {
    try {
        const provider = new GoogleAuthProvider();

        const { user } = await signInWithPopup(auth, provider);

        return user;
    } catch (error) {
        if (
            error.code !== 'auth/cancelled-popup-request' &&
            error.code !== 'auth/popup-closed-by-user'
        ) {
            console.error(error);
        }

        return null;
    }
}

async function logOutFromGoogle() {
    try {
        await auth.signOut();
    } catch (error) {
        console.error(error);
    }
}

export { auth, loginWithGoogle, logOutFromGoogle, SubscribeUserAuthEvent };